//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faKeyboard,
  faSearch,
  faPaperPlane,
  faPuzzlePiece,
} from '@fortawesome/free-solid-svg-icons';
export default {
  data: () => ({
    cards: [
      {
        icon: faKeyboard,
        title: 'Web Development',
        text:
          'Rapid prototyping of bespoke designs into fast, feature rich websites.',
      },
      {
        icon: faSearch,
        title: 'SEO',
        text:
          'Organically raise high quality content to the top of search results.',
      },
      {
        icon: faPaperPlane,
        title: 'Messaging',
        text:
          'Keep the conversation going with multi-channel messaging automation.',
      },
      {
        icon: faPuzzlePiece,
        title: '24/7 Support',
        text:
          'Dedication to maintaining quality websites means we are always reachable.',
      },
    ],
  }),
};
